import ID from '../models/ID'

export interface PlatformFilterState {
  isActive: boolean
  filterNoPlatform: boolean
  selectedPlatformIntIds: Set<number>
}

// True when the Platforms filter hides an item with these platform IDs.
// "No Platform" keeps only items without platforms; a selection keeps items with at least one selected platform.
export function isExcludedByPlatformFilter(platformIds: ID[], state: PlatformFilterState): boolean {
  if (!state.isActive) {
    return false
  }
  if (state.filterNoPlatform) {
    return platformIds.length > 0
  }
  if (platformIds.length === 0) {
    return true
  }
  return !platformIds.some((id) => state.selectedPlatformIntIds.has(id.intID))
}
